module.exports = "/_next/static/images/GetHistory@2x-af85f681cfdd9fba1381d8b760e23660.png";